import { i18n } from '@client/helper/i18n';
import { activityDetailStore } from '@client/store/activityDetailStore';
import { computed, ref, onMounted, watch, onBeforeUnmount } from 'vue';
import { usePakHo } from '../../../hooks/usePakHo';
import SportMap from '../SportMap/SportMap';
import { MarkLap } from '../SportMap/MarkLap/MarkLap';
import { getGodvMapConstructor } from '../utils/get-godv';
import { getGmapConstructor } from '../utils/get-gmap';
import { initStore } from '@client/store/initStore';
import { useActivityDetail } from '../../../hooks/useActivityDetail';

const markLap = ref();
const sportMap = ref();
const stateMap = ref();
const googleMapBounds = ref();

export function useMap({ setPakHoPoint, isGoogle } = {}) {
  const activityDetailStoreRef = activityDetailStore();
  const { unitType } = useActivityDetail();

  const initStoreRef = initStore();
  const THEME = initStoreRef.theme;

  const dom_id = `${isGoogle ? 'googleMap' : 'GodMap'}-${Math.random().toString(36).slice(-6)}`;

  const snowStop = computed(() => {
    return activityDetailStoreRef.activityDetail?.snowStop || [];
  });
  // 是否显示地图卡片
  const mapCardVisible = computed(() => activityDetailStoreRef.mapCardVisible);

  // 鼠标对应图表点的数据
  const { pakHo } = usePakHo();
  if (setPakHoPoint) {
    watch(pakHo, () => {
      setPakHoPoint(pakHo.value);
    });
  }

  const { frequencyList, summary, mapPoiList } = activityDetailStoreRef.activityDetail;

  // sidebar/sport-map/index.vue 进来不需要生成实例
  if (setPakHoPoint && markLap) {
    onMounted(() => {
      const _promise = isGoogle ? getGmapConstructor() : getGodvMapConstructor();
      _promise.then((MapConstructor) => {
        sportMap.value = new SportMap({
          MapConstructor,
          summary,
          mapPoiList,
          frequencyList,
          theme: THEME,
          lang: i18n.locale,
          showBasicMap: activityDetailStoreRef.hasGisAuthority
        });
      });
    });
    onBeforeUnmount(() => {
      markLap.value = null;
    });
  }

  function refreshLapMarkers() {
    if (mapCardVisible.value && markLap.value) {
      const markers = markLap.value.calcMaximum4markers(activityDetailStoreRef.activityDetail?.frequencyList);

      markers.renderMarker4laps();
    }
  }

  let binded = false;
  const bindZoomChange = function () {
    if (binded) return;
    if (isGoogle) {
      stateMap.value.addListener('zoom_changed', refreshLapMarkers);
    } else {
      if (!stateMap.value?.on) return;
      stateMap.value.on('zoomchange', refreshLapMarkers);
    }
    binded = true;
  };

  async function initMarkLap() {
    // console.log(`🔔 initMarkLap`);
    // 重新初始化 binded 状态
    binded = false;
    const mPromise = sportMap.value.initMap(isGoogle, dom_id).then((map) => {
      markLap.value = new MarkLap(isGoogle, map, unitType.value);
      stateMap.value = map;

      return map;
    });
    if (isGoogle) {
      return mPromise;
    }
    // 高德要转换坐标
    return Promise.all([mPromise, sportMap.value.normalizeGps(JSON.parse(JSON.stringify(frequencyList)))]);
  }

  return { dom_id, markLap, snowStop, pakHo, sportMap, stateMap, googleMapBounds, initMarkLap, bindZoomChange };
}
